/** Browser-exposed portal config. Vite inlines `VITE_*` at build time. */

export function portalApiUrl(): string {
  return import.meta.env.VITE_API_URL || "http://localhost:8010/api";
}

export function portalUseMsw(): boolean {
  return import.meta.env.VITE_USE_MSW === "true";
}

export function portalSentryDsn(): string {
  return import.meta.env.VITE_SENTRY_DSN ?? "";
}

export function portalSentryEnvironment(): string {
  return import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;
}

export function portalSentryTracesSampleRate(): number {
  return Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0.1");
}

export function isDevBuild(): boolean {
  return import.meta.env.DEV;
}
